import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { IsEmriDialog } from "@/components/IsEmriDialog";
import api, { errMsg } from "@/lib/api";

const RENK = { kirmizi: "bg-red-600 text-white", yesil: "bg-emerald-600 text-white", turuncu: "bg-amber-500 text-black", mavi: "bg-blue-600 text-white", sari: "bg-yellow-400 text-black", gri: "bg-white/10 text-muted-foreground" };
export const DURUM_HUCRE = {
  stok: { stokta: ["STOKTA VAR", "yesil"], kismi: ["KISMİ STOK", "sari"], yok: ["STOKTA YOK", "kirmizi"], sevk_edildi: ["SEVK EDİLDİ", "gri"] },
  hammadde: { hazir: ["HAMMADDE VAR", "yesil"], yok: ["STOKTA YOK", "kirmizi"], recete_yok: ["REÇETE BULUNAMADI", "mavi"] },
  uretim: { uretimde: ["ÜRETİMDE", "turuncu"] },
  teslimat: { teslim: ["TESLİM EDİLDİ", "yesil"], kismi: ["KISMİ SEVK", "sari"], bekliyor: ["BEKLİYOR", "turuncu"] },
  fatura: { faturalandi: ["FATURALANDIRILDI", "yesil"], bekliyor: ["FATURA BEKLİYOR", "gri"] },
};

export const Hucre = ({ tur, deger, testid }) => {
  const d = DURUM_HUCRE[tur][deger];
  if (!d) return <td className="p-1" data-testid={testid} />;
  return <td className="p-1" data-testid={testid}><div className={`text-[10px] font-bold text-center px-2 py-2 rounded ${RENK[d[1]]}`}>{d[0]}</div></td>;
};

export const UretHucre = ({ s, onDone }) => {
  const [dlg, setDlg] = useState(null);
  const ac = async (e) => {
    e.stopPropagation();
    try {
      const [u, i, d, p] = await Promise.all([api.get("/urunler"), api.get("/istasyonlar"), api.get("/depolar"), api.get("/uretim/personel")]);
      setDlg({ urunler: u.data, istasyonlar: i.data, depolar: d.data, personel: p.data });
    } catch (er) { toast.error(errMsg(er)); }
  };
  const ilk = s.uretim_planlanacak?.[0];
  if (s.durumlar?.uretim === "uretimde" && !ilk) return <Hucre tur="uretim" deger="uretimde" testid={`sip-uretim-${s.no}`} />;
  return (
    <td className="p-1 text-center" data-testid={`sip-uretim-${s.no}`} onClick={(e) => e.stopPropagation()}>
      {ilk && <button data-testid={`sip-uret-${s.no}`} onClick={ac} className="inline-flex items-center gap-1 text-xs px-2 py-1.5 rounded hover:bg-white/10"><Plus className="w-3.5 h-3.5" />Üret</button>}
      {dlg && <IsEmriDialog ihtiyaclar={s.uretim_planlanacak.filter((x) => x.urun_id === ilk.urun_id)} {...dlg} onClose={() => setDlg(null)} onSaved={() => { setDlg(null); onDone(); }} />}
    </td>
  );
};
